import createIcon from '../../createIcon';

/**
 * @component @name HouseSiding
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMTIuNUgyMkwxMiAzLjVMMiAxMi41SDVWMjAuNUg3VjE4LjVIMTdWMjAuNUgxOVYxMi41Wk03LjIxIDEwLjVIMTYuNzlMMTcgMTAuNjlWMTIuNUg3VjEwLjY5TDcuMjEgMTAuNVpNMTQuNTcgOC41SDkuNDNMMTIgNi4xOUwxNC41NyA4LjVaTTcgMTYuNVYxNC41SDE3VjE2LjVIN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HouseSiding = createIcon('HouseSiding', [
  [
    'path',
    {
      d: 'M19 12.5H22L12 3.5L2 12.5H5V20.5H7V18.5H17V20.5H19V12.5ZM7.21 10.5H16.79L17 10.69V12.5H7V10.69L7.21 10.5ZM14.57 8.5H9.43L12 6.19L14.57 8.5ZM7 16.5V14.5H17V16.5H7Z',
      key: 'k3j5ja',
    },
  ],
]);

export default HouseSiding;
